import { useEffect } from 'react';
import { Prompt } from 'react-router-dom';

const stepLinks = [''];

export const FormPrompt = ({ hasUnsavedChanges }) => {
  useEffect(() => {
    // console.log('hasUnsavedChanges', hasUnsavedChanges);

    const onBeforeUnload = (e) => {
      if (hasUnsavedChanges) {
        e.preventDefault();
        e.returnValue = '';
      }
    };
    window.addEventListener('beforeunload', onBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', onBeforeUnload);
    };
  }, [hasUnsavedChanges]);

  const onLocationChange = (location) => {
    if (stepLinks.includes(location.pathname)) {
      return true;
    }
    return 'Tiene datos sin guardar. Recuerde GUARDAR antes de salir. ¿Desea salir perdiendo la información no guardada? ';
  };

  return <Prompt when={hasUnsavedChanges} message={onLocationChange} />;
};
